export const errorMessages = {
  default:
    "Something went wrong. Please try again or contact support if the error persists.",
  noClientIdFound:
    "No client id found for the current teamSchema. Please check the CLIENT_ID_MAPPING in teamConfigs.",
};
